import React, { useReducer, useState, useEffect } from 'react';
import style from './CarriageEdit.module.css';
import axios from '../../functions/axios';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import DropdownList from 'react-widgets/DropdownList';
import { DatePicker, Localization } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import moment from 'moment';
import 'react-widgets/styles.css';
import './EditCarriage.css';
import { parseDate } from '../../functions/functions';

function EditCarriage() {
  const formReducer = (state, event) => {
    return {
      ...state,
      [event.name]: event.value,
    };
  };
  const [formData, setFormData] = useReducer(formReducer, {
    day: parseDate().day, // date
    routeStart: '', // string
    routeEnd: '', // string
    counterStart: 0, // number
    counterEnd: 0, // number
    cost: 0, // number
    invoice: '', // string
    oneTimeClient: '', // string
    carriageWeight: '',
    currency: 'EUR', //string
    invoiceDate: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [cars, setCars] = useState([]);
  const [clients, setClients] = useState([]);
  const [lastCarCarriage, seLastCarCarriage] = useState({});
  const [timocomID, setTimocomID] = useState('-');
  const { user } = useAuthContext();
  const [allowInvoiceDate, setAllowInvoiceDate] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    if (!user) return null;
    return (() => {
      return Promise.all([getData('/driver', setDrivers), getData('/car', setCars), getData('/client', setClients)]);
    })();
  }, [user]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setSubmitting(true);
    await axios.post(`/carriage`, formData);
    setTimeout(() => {
      setSubmitting(false);
    }, 3000);
    navigate('/carriageList', { state: { date: formData.day } });
  };

  const handleChange = (event) => {
    if (event.target.name === 'car' && event.target.value) {
      (async () => {
        const { data: response } = await axios.get(`/carriageByCar`, {
          params: { carId: event.target.value },
        });
        if (!response.counterEnd || !response.driver?._id) return;
        // formData.counterStart = response.counterEnd;
        formData.driver = response.driver._id;
        seLastCarCarriage(response);
      })();
    }
    if (event.target.name === 'client' && event.target.value) {
      const currentId = clients.find((client) => client._id === event.target.value)?.timocomID;
      setTimocomID(() => currentId ?? '-');
    }
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  return (
    <div className={style.wrapper}>
      <form onSubmit={handleSubmit}>
        <div className={style.section}>
          <h2>Wprowadzanie nowej trasy</h2>
          <br />
          <div className={style.row}>
            <label className={style.category} htmlFor='day'>
              Data
            </label>
            <Localization
              date={
                new DateLocalizer({
                  culture: 'pl-PL',
                  firstOfWeek: 1,
                })
              }
            >
              <DatePicker
                value={new Date(formData.day)}
                valueEditFormat={{ dateStyle: 'long' }}
                valueDisplayFormat={{ dateStyle: 'long' }}
                placeholder='miesiąc/dzień/rok'
                onChange={(value) => {
                  handleChange({ target: { name: 'day', value: parseDate(value).day } });
                }}
              />
            </Localization>
            {/* <input type='date' id='day' name='day' onChange={handleChange} value={formData.day || new Date().toISOString()} /> */}
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.row}>
            <label className={style.category} htmlFor='client-data'>
              Klient
            </label>
            <DropdownList
              id='client-data'
              style={{ width: '200px', marginRight: '10px' }}
              defaultValue='--Wybierz z listy--'
              dataKey='id'
              textField='value'
              filter='contains'
              onChange={(option) => handleChange({ target: { name: 'client', value: option.id } })}
              data={[{ id: 'schema.remove', value: '--Wybierz z listy--' }, ...clients.map((client) => ({ id: client._id, value: client.companyName }))]}
            />
            {/* <label className={style.labelShort} htmlFor='one-time-client'>lub dodaj klienta:</label>
            <input id='one-time-client' name='oneTimeClient' type='text' onChange={handleChange} defaultValue={formData.oneTimeClient || ''} /> */}
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='timocom-data'>
              TIMOCOM ID:
            </label>
            {/* <div className={style.labelShort}>{timocomID}</div> */}
            <input
              style={{ width: '200px', marginRight: '10px' }}
              id='timocom-data'
              name='timocomID'
              type='text'
              onChange={handleChange}
              value={formData.timocomID ?? clients.find((client) => client._id === formData.client)?.timocomID ?? ''}
            />
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.row}>
            <label className={style.category} htmlFor='car-data'>
              Pojazd:
            </label>
            <DropdownList
              id='car-data'
              style={{ width: '200px', marginRight: '10px' }}
              defaultValue='--Wybierz z listy--'
              dataKey='id'
              textField='value'
              filter='contains'
              onChange={(option) => handleChange({ target: { name: 'car', value: option.id } })}
              data={[{ id: 'schema.remove', value: '--Wybierz z listy--' }, ...cars.map((car) => ({ id: car._id, value: car.plate }))]}
            />
          </div>
        </div>
        <div className={style.section}>
          <div className={style.row}>
            <label className={style.category} htmlFor='driver-data'>
              Kierowca:
            </label>
            <DropdownList
              id='car-data'
              style={{ width: '200px', marginRight: '10px' }}
              defaultValue='--Wybierz z listy--'
              dataKey='id'
              filter='contains'
              textField='value'
              onChange={(option) => handleChange({ target: { name: 'driver', value: option.id } })}
              data={[{ id: 'schema.remove', value: '--Wybierz z listy--' }, ...drivers.map((driver) => ({ id: driver._id, value: driver.name }))]}
            />
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.category}>Opis trasy</div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-start-data'>
              Skąd:
            </label>
            <input
              style={{ width: '550px', marginRight: '10px' }}
              id='route-start-data'
              name='routeStart'
              type='text'
              onChange={handleChange}
              value={formData.routeStart || lastCarCarriage.routeEnd || ''}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-end-data'>
              Dokąd:
            </label>
            <input
              style={{ width: '550px', marginRight: '10px' }}
              id='route-end-data'
              name='routeEnd'
              type='text'
              onChange={handleChange}
              value={formData.routeEnd || ''}
            />
          </div>

          <div className={style.row}>
            <label className={style.category}>Liczba km:</label>
            {/* <label className={style.subcategory} htmlFor='counter-start-data'>              początkowy:            </label> */}
            {/* <input
              id='counter-start-data'
              type='number'
              name='counterStart'
              onChange={handleChange}
              value={formData.counterStart ?? lastCarCarriage.counterEnd ?? 0}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='counter-end-data'>
              końcowy:
            </label> */}
            <input id='counter-end-data' type='number' name='counterEnd' onChange={handleChange} value={formData.counterEnd ?? 0} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='carriageWeight-data'>
              Waga transportu:
            </label>
            <input
              style={{ width: '150px', marginRight: '10px' }}
              className={style.weight}
              id='carriageWeight-data'
              name='carriageWeight'
              type='text'
              onChange={handleChange}
              value={formData.carriageWeight || ''}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='cost-data'>
              Stawka:
            </label>
            <input
              type='number'
              min='0'
              step='any'
              id='cost-data'
              name='cost'
              onChange={handleChange}
              checked={formData.cost ?? 0}
              disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
            />
            <select
              name='currency'
              id='currency'
              defaultValue='EUR'
              onChange={handleChange}
              disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
            >
              <option value='EUR'>EURO €</option>
              <option value='PLN'>PLN zł</option>
            </select>
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='invoice-data'>
              Nr faktury
            </label>
            <input
              style={{ width: '150px', marginRight: '10px' }}
              id='invoice-data'
              name='invoice'
              type='text'
              onChange={handleChange}
              value={formData.invoice || ''}
              disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
            />
          </div>
          <div className={style.row}>
            <label className={style.category} htmlFor='day-data'>
              Termin płatności
            </label>
            <input
              style={{ width: '150px', marginRight: '10px' }}
              type='checkbox'
              onChange={(event) => {
                setAllowInvoiceDate(event.target.checked);
                if (!event.target.checked) {
                  handleChange({ target: { name: 'invoiceDate', value: undefined } });
                }
              }}
              checked={allowInvoiceDate}
              disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
            />
            {allowInvoiceDate && (
              <Localization
                date={
                  new DateLocalizer({
                    culture: 'pl-PL',
                    firstOfWeek: 1,
                  })
                }
              >
                <DatePicker
                  value={formData?.invoiceDate ? new Date(formData?.invoiceDate) : null}
                  valueEditFormat={{ dateStyle: 'long' }}
                  valueDisplayFormat={{ dateStyle: 'long' }}
                  placeholder='miesiąc/dzień/rok'
                  disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
                  onChange={(value) => {
                    handleChange({ target: { name: 'invoiceDate', value: parseDate(value).day } });
                  }}
                />
              </Localization>
            )}
          </div>

          <hr />
          <span className={style.buttons}>
            <button className='btn btn-default' onClick={navigate.bind(null, '/carriageList', { state: { date: formData.day } })}>
              Anuluj
            </button>
            <button className='btn btn-default' type='submit'>
              Zapisz
            </button>
          </span>
        </div>
      </form>
    </div>
  );
}

const getData = async (path, callback) => {
  try {
    const { data: response } = (await axios.get(path)) || [];
    response.sort((...args) => {
      const [a, b] = args.map(({ name, plate, companyName }) => name || plate || companyName);
      return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
    });
    callback(response);
  } catch (error) {
    console.error(error.message);
  }
};

export default EditCarriage;
